export default __webpack_public_path__ + "static/truth-aa3f187781674829e1d6edff29fb7b6b.svg";